import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { currentUser } from 'spw-redux/modules/user/selectors';
import * as GA from 'spw-shared/analytics';
import { debounce } from 'lodash';

export const useTrackWorksheetActions = (
  projectType: string,
  contentRef: React.MutableRefObject<HTMLDivElement>
) => {
  const [activated, setActivated] = useState(false);
  const user = useSelector(currentUser);

  const handleClick = useCallback(() => {
    if (activated === false) {
      setActivated(true);
      GA.event({
        category: projectType as GA.GACategory,
        subCategory: 'Worksheet',
        action: GA.tag('SHEET_VIEW', projectType),
        label: JSON.stringify({
          projectType,
          userId: user?.id,
        }),
      });
    }
  }, [activated, user?.id, projectType]);

  const onScroll = debounce(() => {
    GA.event({
      category: projectType as GA.GACategory,
      subCategory: 'Worksheet',
      action: GA.tag('SHEET_SCROLL', projectType),
      label: JSON.stringify({
        projectType,
        userId: user?.id,
      }),
    });
  }, 500);

  useEffect(() => {
    const content = contentRef.current;
    content.addEventListener('scroll', onScroll, false);
    return () => {
      content.removeEventListener('scroll', onScroll, false);
    };
  }, [onScroll, contentRef]);

  return {
    handleClick,
  };
};
